<template>
  <div class="cardCouponList">
    <div class="contentRight2">
      <div class="contentTabs">
        <div class="rightHead">
          <div
            style="margin:0 0 0 30px;font-size:15px;padding-top:5px;color:#707070;"
            v-if="$route.meta.titleShow"
          >
            {{ $route.name }}
          </div>
          <div class="invoicingHead" style="height: 40px">
            <el-breadcrumb
              class="elArrowText"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="content-box">
          <div class="row">
            <div style="padding: 5px 5px 5px 0">使用时间</div>
            <el-date-picker
              v-model="dateTime"
              @change="dateChange"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-button
              type="primary"
              style="margin-left:10px"
              size="small"
              @click="search"
              >搜索</el-button
            >
          </div>
          <div class="row" style="padding-top:30px;box-sizing:border-box;">
            <div class="pr30">营销统计</div>
            <div class="pr30 bold">
              已使用： <span class="colorblue">{{ usedCount }}</span> 张
            </div>
            <div class="pr30 bold">
              合计： <span class="color-orange">{{ deductionAmount }}</span> 元
            </div>
          </div>
          <el-table
            :data="tableData"
            style="width: 100%;padding-top:30px;box-sizing:border-box;"
            v-loading="loading"
            element-loading-background="rgba(0, 0, 0, 0.3)"
            element-loading-text="数据正在加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column align="center" prop="userName" label="用户" />
            <el-table-column align="center" prop="usedTime" label="时间" />
            <el-table-column align="center" prop="price" label="优惠券金额" />
          </el-table>
          <!-- 分页 -->
          <div
            v-if="tableData.length > 0"
            class="block"
            style="float:right;margin-top:10px;"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="queryInfo.pageNo"
              :page-size="queryInfo.row"
              layout="total, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCashCouponUsedDetailList } from "../api/index";
export default {
  data() {
    return {
      dateTime: "",
      usedCount: "",
      deductionAmount: "",
      loading: false,
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10
      },
      total: 0,
      userList: {},
      status: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getCashCouponUsedDetailList();
  },
  methods: {
    getCashCouponUsedDetailList(startDate, endDate) {
      getCashCouponUsedDetailList({
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId,
        pageNumber: this.queryInfo.pageNo,
        startDate: startDate,
        endDate: endDate
      }).then(res => {
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.usedCount = res.data.statistics.usedCount;
          this.deductionAmount = res.data.statistics.deductionAmount;
        } else if (res.code == -1) {
          this.usedCount = 0;
          this.deductionAmount = 0;
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getCashCouponUsedDetailList();
      } else {
        this.getCashCouponUsedDetailList(this.startDate, this.endDate);
      }
    },
    dateChange(date) {
      if (!date) {
        this.getCashCouponUsedDetailList();
        return;
      }
      this.startDate = date[0];
      this.endDate = date[1];
    },
    search() {
      this.queryInfo.pageNo = 1;
      this.status = 1;
      this.getCashCouponUsedDetailList(this.startDate, this.endDate);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table th {
  background-color: #f8f8f8;
}
.content-box {
  width: calc(100vw - 280px);
  position: absolute;
  top: 120px;
  padding: 0 30px;
}
.colorblue {
  color: #3388ff;
}
.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}
.bold {
  font-weight: bold;
  .color-orange {
    color: #ff7757;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/cardCouponList.vue